import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  LuPlus, 
  LuRocket, 
  LuZap, 
  LuSettings 
} from 'react-icons/lu';

const QuickActions = ({ listings }) => {
  const navigate = useNavigate();

  const actions = [
    {
      id: 'create-listing',
      title: 'Create Listing',
      icon: LuPlus,
      color: 'bg-gradient-to-r from-orange-500 to-red-500',
      iconColor: 'text-white',
      onClick: () => navigate('/store/listings/create-listing')
    },
    {
      id: 'boost-history',
      title: 'Boost History',
      icon: LuRocket,
      color: 'bg-gradient-to-r from-green-500 to-emerald-500',
      iconColor: 'text-white',
      onClick: () => navigate('/store/boost-history')
    },
    {
      id: 'boost-listing',
      title: 'Boost Listing',
      icon: LuZap,
      color: 'bg-gradient-to-r from-yellow-500 to-amber-500',
      iconColor: 'text-white',
      onClick: () => {
        const activeListing = listings?.find(l => l.status === 'active');
        if (activeListing) {
          navigate('/store/boost-package/listings');
        } else {
          if (window.confirm(
            'No Active Listings\nCreate a listing first to use the boost feature!\n\nClick OK to create a listing.'
          )) {
            navigate('/store/listings/create-listing');
          }
        }
      }
    },
    {
      id: 'store-settings',
      title: 'Store Settings',
      icon: LuSettings,
      color: 'bg-gradient-to-r from-blue-500 to-indigo-500',
      iconColor: 'text-white',
      onClick: () => navigate('/store/settings')
    }
  ];

  return (
    <>
      <h2 className="text-lg font-bold text-black mb-4">Quick Actions</h2>
      <div className="grid grid-cols-2 gap-4">
        {actions.map((action) => {
          const Icon = action.icon;
          return (
            <button
              key={action.id}
              onClick={action.onClick}
              className="flex flex-col items-center p-4 bg-white rounded-xl shadow-sm border border-gray-200 hover:border-orange-200 hover:shadow transition-all focus:outline-none focus:ring-2 focus:ring-orange-500"
            >
              <div className={`p-3 rounded-full ${action.color} mb-2`}>
                <Icon className={`w-6 h-6 ${action.iconColor}`} />
              </div>
              <span className="text-sm font-medium text-gray-900 text-center">
                {action.title}
              </span>
            </button>
          );
        })}
      </div>
    </>
  );
};

export default QuickActions;